<template>
    <div class="map-footer">
        <div
            v-show="scrollEnable"
            class="scroll-map"
        >
            <button
                class="scroll-map__btn"
                :disabled="isReachedLeftLimit"
                @click="scrollToLeft()"
            >
                <ChevronLeftIcon />
            </button>
            <button
                class="scroll-map__btn scroll-map__btn--right"
                :disabled="isReachedRightLimit"
                @click="scrollToRight()"
            >
                <ChevronLeftIcon />
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import ChevronLeftIcon from '@/components/commons/icons/ChevronLeftIcon.vue';
    import { landPlotStore } from '@/store/modules/LandPLot';
    import { cardSettingsStore } from '@/store/modules/CardSettings';

    const scrollEnable = computed(() => {
        const vw = cardSettingsStore.SCROLL_DATA_OBJECT.vw;

        if (!vw) return false;

        return cardSettingsStore.MAP_DOM_RECT.width < vw;
    });

    const isReachedLeftLimit = computed(() => {
        return cardSettingsStore.CURRENT_TRANSLATE_X >= 0;
    });

    const isReachedRightLimit = computed(() => {
        return (
            cardSettingsStore.CURRENT_TRANSLATE_X <=
            cardSettingsStore.SCROLL_DATA_OBJECT.Xmax
        );
    });

    function scrollToLeft() {
        if (isReachedLeftLimit.value) return;

        cardSettingsStore.SET_TRANSLATE_X(cardSettingsStore.TRANSLATE_X + 100);
    }

    function scrollToRight() {
        if (isReachedRightLimit.value) return;

        cardSettingsStore.SET_TRANSLATE_X(cardSettingsStore.TRANSLATE_X - 100);
    }
</script>

<style lang="less">
    .map-footer {
        position: absolute;
        bottom: 10px;
        transform: translateX(-50%);
        left: 50%;
    }

    .scroll-map {
        display: flex;
        gap: 8px;

        // .scroll-map__btn
        &__btn {
            width: 44px;
            height: 44px;
            border-radius: 100px;
            border: 0;
            background-color: rgba(@simple-light, 0.8);
            color: @success;
            line-height: 0;
            text-align: center;
            cursor: pointer;
            @media (max-width: @size-mobile-top) {
            background-color: #F6F6F6;
            }
            svg {
                line-height: 0;
                height: 14px;
            }

            &[disabled] {
                opacity: 0.7;
                cursor: not-allowed;
            }

            &--right {
                transform: rotate(180deg);
            }
        }
    }
</style>
